<template>
  <div class="friendly-link mt-30">
    <div class="friend-link">
      <div 
        v-for="(group, index) in linkList" 
        :key="index" 
        class="link-item"
        @click.stop="toggleDropdown(index)"
        :class="{ 'active': activeDropdown === index }"
      >
        <span>{{ group.title }}</span>
        <ul class="link-drop" :style="{ display: activeDropdown === index ? 'block' : 'none' }">
          <li v-for="(link, linkIndex) in group.links" :key="linkIndex">
            <a 
              rel="nofollow" 
              :href="link.url" 
              target="_blank" 
              :title="link.name"
            >
              {{ link.name }}
            </a>
          </li>
        </ul>
        <i :class="{ 'rotate': activeDropdown === index }"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import linkApi from "@/api/link";
import { getConstantDic, LINK_TYPE, SELECT_OPTION_CONFIG } from "@/utils/constant";

export default {
  name: "FriendlyLink",
  components: { Link },
  data() {
    return {
      activeCode: LINK_TYPE.LINK_ZFBM[SELECT_OPTION_CONFIG.CODE],
      // linkList: {
      //   link_zfbm: [],
      //   link_jtbk: [],
      //   link_hzjg: []
      // },
      activeDropdown: null,
      linkList: [
        {
          title: "------ 政府部门 ------",
          links: [
          ]
        },
        {
          title: "------ 集团板块 ------",
          links: [
          ]
        },
        {
          title: "------ 合作机构 ------",
          links: [
          ]
        }
      ]
    };
  },
  computed: {
    friendlyLinks() {
      return getConstantDic(LINK_TYPE)
    },
    showListData() {
      return this.linkList[this.activeCode] || []
    },
    isCardItem() {
      return this.activeCode === LINK_TYPE.LINK_ZFBM[SELECT_OPTION_CONFIG.CODE];
    },
    moreUrl() {
      return "/friendlyLink/list/" + this.activeCode
    }
  },
  created() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.closeAllDropdowns);
  },
  beforeDestroy() {
    // Clean up event listener
    document.removeEventListener('click', this.closeAllDropdowns);
  },
  mounted() {
    this.getListData()
  },
  methods: {
    getListData() {
      const linkCodes = this.friendlyLinks.map(item => item[SELECT_OPTION_CONFIG.CODE])
      const codeToIndexMap = {
        'link_zfbm': 0,
        'link_jtbk': 1,
        'link_hzjg': 2
      };
      Promise.all(linkCodes.map(type => {
        return linkApi
          .list({
            type
          })
      })).then(res => {
        res?.forEach(({ data }, i) => {
          const currentCode = linkCodes[i];
          if (codeToIndexMap.hasOwnProperty(currentCode)) {
            this.linkList[codeToIndexMap[currentCode]].links = data || [];
          }
        });
      })
    },
    toggleDropdown(index) {
      if (this.activeDropdown === index) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = index;
      }
    },
    closeAllDropdowns() {
      this.activeDropdown = null;
    }
  }
};
</script>

<style scoped lang="scss">
.friendly-link{
  width: 1200px;
  margin: 0 auto;
}
.friend-link {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 75px 0;

  .link-item {
    position: relative;
    line-height: 50px;
    cursor: pointer;
    font-size: 14px;
    color: #333333;
    height: 50px;
    background: #FFFFFF;
    display: inline-block;
    width: 280px;
    border: 1px solid #ddd;
    
    &:hover {
      border-color: #E15717;
    }
    
    > span {
      display: block;
      text-align: center;
      user-select: none;
    }
    
    &.active {
      border-color: #E15717;
    }
  }
  
  .link-drop {
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 50px;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    z-index: 99;
    box-shadow: 0 5px 5px rgba(0,0,0,0.1);
    
    li {
      height: 30px;
      
      &:hover {
        background-color: #E15717;
      }
    }
    
    a {
      display: block;
      height: 100%;
      line-height: 30px;
      max-width: 100%;
      color: #666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      
      &:hover {
        color: #fff;
      }
    }
  }
  
  i {
    transition: all 0.3s;
    position: absolute;
    right: 12px;
    top: 23px;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px;
    border-top-color: #000;
    
    &.rotate {
      transform: rotate(180deg);
      transform-origin: center 2.5px;
    }
  }
}
</style>